$(document).ready(function () {
  const hero = $("#shopify-section-diy-hero");
  const heroHeight = hero?.height() || 488;

  $(window).scroll(function () {
    if ($(this).scrollTop() > heroHeight + 100) {
      $("body").addClass("diy_sidebara");

      setTimeout(() => {
        $(".diy_sidebara .sticky_di_bar").addClass("diy_sticky_bar_show");
      }, 500);
    } else {
      $("body").removeClass("diy_sidebara");
      $(".sticky_di_bar").removeClass("diy_sticky_bar_show");
    }
  });

  // Sticky nav bar
  $(".sticky_di_bar ul li a").click(function () {
    $(".sticky_di_bar ul li a").removeClass("active_diy");
    $(this).addClass("active_diy");
  });

  // Smooth scroll to element
  if ($(window).width() < 769) {
    $(".sticky_di_bar ul li a").click(function () {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $($(this).attr("href")).offset().top - 55,
        },
        100
      );
      return true;
    });

    $(".sticky_di_bar ul li,.blogs-menu-chart-cantent ul li a").click(
      function () {
        $(".blogs-menu-chart-cantenter").removeClass("opened");
      }
    );
  } else {
    $(".sticky_di_bar ul li a").click(function () {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $($(this).attr("href")).offset().top - 72,
        },
        100
      );
      return true;
    });
  }

  // diy-steps.liquid
  const videoModals = document.querySelectorAll(".diy-video-modal");

  for (let i = 0; i < videoModals.length; i++) {
    const videoModal = videoModals[i];

    const modalOpenBtn = videoModal.querySelector(".diy-modal-open-btn");
    const modalWrapper = videoModal.querySelector(".diy-modal-wrapper");
    const modalOverlay = videoModal.querySelector(".diy-modal-overlay");
    const modalContent = videoModal.querySelector(".diy-modal-content");
    const modalCloseBtn = videoModal.querySelector(".diy-modal-close-btn");
    const iframe = videoModal.querySelector(".diy-modal-content iframe");
    const iframeSrc = iframe.src;

    function showModal() {
      modalWrapper.classList.add("active");
      $("body").css("overflow", "hidden");
      iframe.src = iframeSrc;

      setTimeout(() => {
        modalOverlay.classList.add("active");
        modalContent.classList.add("active");
      }, 200);
    }

    function hideModal() {
      modalWrapper.classList.remove("active");
      modalOverlay.classList.remove("active");
      modalContent.classList.remove("active");
      $("body").css("overflow", "auto");
      iframe.src = "";
    }

    modalOpenBtn.addEventListener("click", showModal);
    modalCloseBtn.addEventListener("click", hideModal);
    modalOverlay.addEventListener("click", hideModal);
  }

  // diy-reviews.liquid
  const reviewSlider = $(".diy-reviews-slider");

  if (reviewSlider) {
    reviewSlider.slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
          },
        },
      ],
    });
  }

  const quickReorderSlider = $(".diy-quick-reorder-slider");

  if (quickReorderSlider) {
    quickReorderSlider.slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: "unslick",
        },
      ],
    });
  }
});
